import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import FullScreenLoader from "@/components/loaders/FullScreenLoader";
import { ROUTES } from "@/helpers/routes/routePaths";
import { logoutAction } from "@/features/auth/store/logoutAction";

type LogoutDispatch = (_logoutThunk: ReturnType<typeof logoutAction>) => void;

function LogoutCallbackPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const dispatchLogout = dispatch as unknown as LogoutDispatch;
    dispatchLogout(logoutAction());
    navigate(ROUTES.LOGIN, { replace: true });
  }, [dispatch, navigate]);

  return <FullScreenLoader isActive message="Signing out..." />;
}

export default LogoutCallbackPage;
